import React from "react";
import {
  Box,
  Tabs,
  Tab,
  Button,
  IconButton,
  CircularProgress,
} from "@mui/material";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import Label from "../../../components/Label/Label";

const HeaderTabsBar = ({
  activeTab,
  setActiveTab,
  state,
  currentChartConfigState,
  configSetIds,
  saving,
  disableAllFields,
  setSaveDialogOpen,
  setOpen,
  index,
  firstChartIdToShowSave,
  chartId,
  product,
  site,
}) => {
  console.log("HeaderTabsBar render", state.parameterState.plotType);
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mb: 1,
        // position: "fixed",
        width: "-webkit-fill-available",
        zIndex: 2,
        backgroundColor: "#e8edf4",
        padding: "6px 8px",
        boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
        borderRadius: "8px",
      }}
    >
      {/* ---------------- Tabs ---------------- */}
      <Tabs
        value={activeTab}
        onChange={(e, newValue) => setActiveTab(newValue)}
        sx={{
          minHeight: 20,
          pl: 1,
          "& .MuiTab-root": {
            minHeight: 20,
            minWidth: "max-content",
            padding: "2px 8px",
          },
          "& .MuiTabs-flexContainer": {
            gap: 1,

          },
        }}
      >
        <Tab value="chart" label={<Label text="Chart" />} />
        <Tab value="tables" label={<Label text="Raw Data" />} />

        {(state.parameterState.plotType === "pp_chart" ||
          state.parameterState.plotType === "process_capability") && (
            <Tab value="subplots" label={<Label text="Sub Plots" />} />
          )}

        {state.parameterState.plotType === "pp_chart" && (
          <Tab value="histogram" label={<Label text="Histogram" />} />
        )}
      </Tabs>

      {/* ---------------- Breadcrumbs ---------------- */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexWrap: "nowrap",
          gap: 0.5,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          padding: "0px 8px",
        }}
      >
        {/* Parameter */}
        <Box>        {state.parameterState.product?.name && (
          <Label
            fontSize="11px"
            text={`Product: ${state.parameterState.product.name}`}
            fontWeight="500"
          />
        )}
          {state.parameterState.site?.name && (
            <Label
              fontSize="11px"
              text={`Site: ${state.parameterState.site.name}`}
              fontWeight="500"
            />
          )}
        </Box>{' | '}
        <Box>
          {state.parameterState.unitOfOperation.name && (
            <Label
              fontSize="11px"
              text={`UOP: ${state.parameterState.unitOfOperation.name}`}
              fontWeight="500"
            />
          )}
          {state.parameterState.parameter.label && (
            <Label
              fontSize="11px"
              text={`Parameter: ${state.parameterState.parameter.label}`}
              fontWeight="500"
            />
          )}
        </Box>
        {" | "}
        {state.parameterState.parameter.label &&
          (currentChartConfigState?.specLimitType ||
            currentChartConfigState?.controlLimitType ||
            currentChartConfigState?.specificationTarget) && <span></span>}

        {/* Spec Limit */}
        <Box>
          {currentChartConfigState?.specLimitType === "User Preset" && (
            <Label
              fontSize="11px"
              text={`SL: User Preset (${Array.isArray(configSetIds?.specification_limit_options)
                ? configSetIds?.specification_limit_options?.find(
                  (opt) =>
                    opt.spec_limit_id ===
                    currentChartConfigState?.specLimitSetId,
                )?.identifier || "N/A"
                : "N/A"
                })`}
            />
          )}
          {currentChartConfigState?.specLimitType === "User Defined" && (
            <Label
              fontSize="11px"
              text={`SL: User Defined (${[
                currentChartConfigState?.lowerSpecLimit
                  ? `LSL: ${currentChartConfigState?.lowerSpecLimit}`
                  : null,
                currentChartConfigState?.upperSpecLimit
                  ? `USL: ${currentChartConfigState?.upperSpecLimit}`
                  : null,
                currentChartConfigState?.specificationTarget
                  ? `Target: ${currentChartConfigState?.specificationTarget}`
                  : null,
              ]
                .filter(Boolean)
                .join(",")})`}
            />
          )}

          {currentChartConfigState?.specLimitType &&
            (currentChartConfigState?.controlLimitType ||
              currentChartConfigState?.specificationTarget) && <span></span>}

          {/* Control Limit */}
          {currentChartConfigState?.controlLimitType === "User Preset" && (
            <Label
              fontSize="11px"
              text={`CL: User Preset (${Array.isArray(configSetIds?.control_limit_options)
                ? configSetIds?.control_limit_options?.find(
                  (opt) =>
                    opt.stat_limit_id ===
                    currentChartConfigState?.controlLimitSetId,
                )?.set_id || "N/A"
                : "N/A"
                })`}
            />
          )}
          {currentChartConfigState?.controlLimitType === "User Defined" && (
            <Label
              fontSize="11px"
              text={`CL: User Defined (${[
                currentChartConfigState?.lowerControlLimit
                  ? `LCL: ${currentChartConfigState?.lowerControlLimit}`
                  : null,
                currentChartConfigState?.upperControlLimit
                  ? `UCL: ${currentChartConfigState?.upperControlLimit}`
                  : null,
              ]
                .filter(Boolean)
                .join(",")})`}
            />
          )}
          {currentChartConfigState?.controlLimitType === "Sample Calculation" && (
            <Label fontSize="11px" text="CL: Sample Calculation" />
          )}
        </Box>
      </Box>

      {/* ---------------- Buttons ---------------- */}
      <Box display="flex" alignItems="center" gap={1}>
        {activeTab === "subplots" && (
          <IconButton
            size="small"
            onClick={() => setOpen(true)}
            sx={{
              border: "1px solid #ddd",
              zIndex: 2,
              "&:hover": { background: "#f5f5f5" },
            }}
          >
            <FullscreenIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default HeaderTabsBar;
